import { useQuery } from "@tanstack/react-query";
import api from "../api";

// Short stale time so admin-published updates propagate promptly,
// while still caching between navigations / back-forward.
const LIVE = 30_000; // 30s for live result/common
const DERIVED = 60_000; // 60s for computed analytics/predict

// Persist last successful responses in localStorage so a hard refresh
// shows the previous (real) data INSTANTLY, then revalidates in background
// (no "--" / empty-table flash).
const ls = {
  get: (k) => {
    try {
      const v = localStorage.getItem("rqc_" + k);
      return v ? JSON.parse(v) : undefined;
    } catch (e) {
      return undefined;
    }
  },
  set: (k, d) => {
    try {
      localStorage.setItem("rqc_" + k, JSON.stringify(d));
    } catch (e) {}
  },
};

const cached = (key, fn) => async () => {
  const data = await fn();
  ls.set(key, data);
  return data;
};

const makeQuery = (key, fn, staleTime) => ({
  queryKey: [key],
  queryFn: cached(key, fn),
  staleTime,
  placeholderData: (prev) => prev,
  initialData: () => ls.get(key),
  // treat cached data as stale so it revalidates immediately in background
  initialDataUpdatedAt: 0,
});

export const useResults = () =>
  useQuery(makeQuery("results", api.getResults, LIVE));

export const useCommon = () =>
  useQuery(makeQuery("common", api.getCommon, LIVE));

export const useAnalytics = () =>
  useQuery(makeQuery("analytics", api.getAnalytics, DERIVED));

export const usePredict = () =>
  useQuery(makeQuery("predict", api.getPredict, DERIVED));
